import { BannerImageModel } from "../../../api/models";

export function mapBannerImagesToEditorImages(
  bannerImages: BannerImageModel[],
  layoutImages: number,
) {
  const newImages = new Array(layoutImages).fill(null);

  bannerImages
    ?.filter((image) => image.layout === `${layoutImages}img`)
    .forEach((image) => {
      newImages[(image.layoutPosition || 1) - 1] = {
        url: image.fullSizeImage?.url || "",
        previewUrl: image.croppedImage?.url || "",
        position: {
          x: image.x ? image.x / 1000 : 0,
          y: image.y ? image.y / 1000 : 0,
        },
        scale: image.zoomLevelPercent || 1,
        id: image.id,
      };
    });

  return newImages;
}

export function bannerLayoutExists(
  bannerImages: BannerImageModel[],
  layout: number,
) {
  return bannerImages.some((image) => image.layout === `${layout}img`);
}
